import { isType } from "forms/helpers/checkJsonSchemaType";
import parseNumber from "forms/helpers/parsers/parseNumber";
import parseString from "forms/helpers/parsers/parseString";
import type { IProperty } from "types/jsonSchema";
import { type ZodCoercedNumber, type ZodString, z } from "zod";

export default function parseObject(field: IProperty) {
    const shape: Record<string, ZodString | ZodCoercedNumber> = {};

    if (field.properties) {
        Object.entries(field.properties).forEach(([key, value]) => {
            if (!value || !value?.type) return;

            if (isType(value.type, "string")) {
                shape[key] = parseString({
                    type: value.type,
                    minLength: value.minLength,
                });
            }

            if (isType(value.type, "integer")) {
                shape[key] = parseNumber({
                    type: value.type,
                    minLength: value.minLength,
                });
            }
        });
    }

    return z.object(shape);
}
